import React, { useContext, useState } from 'react';

export const Context = React.createContext();

export const useAnalyticsContext = () => useContext(Context);

export const Provider = ({ children }) => {
  const [lastUpdatedTimestamp, setTimestamp] = useState();

  const updateTimestamp = () => setTimestamp(Number(new Date()));

  return (
    <Context.Provider value={[lastUpdatedTimestamp, updateTimestamp]}>
      {children}
    </Context.Provider>
  );
};
